import React, { createContext, useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setupInterceptors } from './axiosinstance';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // const backUrl = "http://127.0.0.1:8000";
  // const backUrl = "http://[IP_ADDRESS]";
  const backUrl = "";
  const bssBackUrl = "https://uatestadmin.bssonetouch.com";
  const googlemapAPI = "https://www.google.com/maps?q=";

  const navigate = useNavigate();

  const [authData, setAuthData] = useState(() => {
    const storedAuthData = localStorage.getItem('authData');
    return storedAuthData ? JSON.parse(storedAuthData) : null;
  });

  // Keep a ref always pointing to the latest authData so interceptors can read it
  const authDataRef = useRef(authData);
  useEffect(() => {
    authDataRef.current = authData;
  }, [authData]);

  // Wire up axios interceptors once on mount
  useEffect(() => {
    const cleanup = setupInterceptors(authDataRef, setAuthData, backUrl, navigate);
    return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = (data) => {
    setAuthData(data);
    localStorage.setItem("authData", JSON.stringify(data));
    localStorage.setItem("welcomeShown", "true");
  };

  const logout = () => {
    localStorage.clear();
    setTimeout(() => {
      setAuthData(null);
    }, 100);
  };

  return (
    <AuthContext.Provider value={{ authData, login, logout, backUrl, bssBackUrl, googlemapAPI }}>
      {children}
    </AuthContext.Provider>
  );
};
